import { Box, Text } from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { CellValue } from 'react-table';

import Table from 'components/Table';
import Title from 'components/Title';
import {
  IEvereePayablesSearchQuery,
  useFetchEvereePaginatedPayables,
} from 'hooks/integrations/everee/useFetchEvereePaginatedPayables';
import { formatCurrency, formatYearMonthDay, formatYearMonthDayTime } from 'utils/format';

const initialSearchQuery: IEvereePayablesSearchQuery = {
  page: 1,
  page_size: 25,
  search: '',
};

const PayablesTable = () => {
  const [searchQuery, setSearchQuery] = useState<IEvereePayablesSearchQuery>(initialSearchQuery);

  const { data, status: fetchPayablesStatus } = useFetchEvereePaginatedPayables(searchQuery);

  const columns = [
    {
      Header: 'Name',
      accessor: 'full_name',
      width: 250,
      Cell: (data: CellValue) => {
        return (
          <Box>
            <Text textOverflow="ellipsis" overflow="hidden" mb={1}>
              {data?.row?.original?.full_name}
            </Text>
            <Text textOverflow="ellipsis" overflow="hidden" color="gray.500">
              {data?.row?.original?.email}
            </Text>
          </Box>
        );
      },
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: (data: CellValue) => {
        return <div>{data.value ? formatYearMonthDay(data.value) : '-'}</div>;
      },
    },
    {
      Header: 'End Date',
      accessor: 'end_date',
      Cell: (data: CellValue) => {
        return <div>{data.value ? formatYearMonthDay(data.value) : '-'}</div>;
      },
    },
    {
      Header: 'Mileage Cost',
      accessor: 'mileage_cost',
      Cell: (data: CellValue) => {
        return <div>{data.value ? formatCurrency(data.value) : '-'}</div>;
      },
    },
    {
      Header: 'Earning Timestamp',
      accessor: 'earning_timestamp',
      Cell: (data: CellValue) => {
        //@ts-ignore
        return <div>{data.value ? formatYearMonthDayTime(data.value * 1000) : '-'}</div>;
      },
    },
    {
      Header: 'Payment Status',
      accessor: 'payment_status',
    },
  ];

  const handlePageChange = useCallback((selectedPageIndex: number) => {
    const updatedSearchQuery = (previousSearchQuery: IEvereePayablesSearchQuery) => ({
      ...previousSearchQuery,
      page: selectedPageIndex + 1,
    });
    setSearchQuery(updatedSearchQuery);
  }, []);

  const handlePageSizeChange = useCallback((pageSize: number) => {
    const updatedSearchQuery = (previousSearchQuery: IEvereePayablesSearchQuery) => ({
      ...previousSearchQuery,
      page_size: pageSize,
      page: 1,
    });
    setSearchQuery(updatedSearchQuery);
  }, []);

  return (
    <Box mt="4">
      <Title>Everee Payables</Title>
      <Table
        columns={columns}
        data={data?.payload || []}
        isLoading={fetchPayablesStatus === 'loading'}
        paginationData={data?.meta_data?.pagination}
        onPageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
    </Box>
  );
};

export default PayablesTable;
